export default "__VITE_ASSET__CVMxXAxL__"